import { Component, inject } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'

import { AuthenticationService } from '../../../utilities/services/authentication.service'
import { RoleRestrictionDirective } from '../../../utilities/directives/role-restriction.directive'
import { Permission } from '../../../utilities/models/user'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ProfileModalComponent } from './profile-modal/profile-modal.component'

@Component({
    selector: 'nav-menu',
    imports: [RouterLink, RouterLinkActive, RoleRestrictionDirective],
    templateUrl: './nav-menu.component.html',
    styleUrl: './nav-menu.component.scss',
})
export class NavMenuComponent {
    private readonly authenticationService = inject(AuthenticationService)
    private readonly modalService = inject(NgbModal)

    readonly permission = Permission

    logout(): void {
        this.authenticationService.logout()
    }

    profileModal(): void {
        const modalRef = this.modalService.open(ProfileModalComponent, { size: 'lg' })
        modalRef.componentInstance.keycloakId = this.authenticationService.getKeycloakId();

        modalRef.result.then((result) => {
            if (result) console.log('Profile updated successfully');
        })
    }
}
